import React from "react"

import NpsRatingButtonGroup from "./NpsRatingButtonGroup"

const feedbackOptions = [
  { text: "10", mobileText: "10 - Very Likely", value: 10 },
  { text: "9", value: 9 },
  { text: "8", value: 8 },
  { text: "7", value: 7 },
  { text: "6", value: 6 },
  { text: "5", value: 5 },
  { text: "4", value: 4 },
  { text: "3", value: 3 },
  { text: "2", value: 2 },
  { text: "1", value: 1 },
  { text: "0", mobileText: "0 - Not Likely", value: 0 },
]

const NpsRatingView = props => {
  return (
    <div>
      <NpsRatingButtonGroup
        options={feedbackOptions}
        onClick={props.onScoreClick}
      />
    </div>
  )
}

export { NpsRatingView as default }



// WEBPACK FOOTER //
// ./assets/feedback/components/nps/NpsRating.js